// extracted by mini-css-extract-plugin
export default {"container":"platter_container__eCvnH","title":"platter_title__gndNG"};